import { IonButtons, IonContent, IonButton, IonHeader, IonLabel, IonToolbar, IonIcon, IonThumbnail, IonItem, IonText, IonCard, IonNote, IonFooter } from "@ionic/react";
import { closeOutline, openOutline } from "ionicons/icons";
import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import './PaymentDetailsPage.css';
import moment from "moment";
import { Asset, DisplayableOperation } from "../../types/types";
import AppHeader from "../../components/AppHeader/AppHeader";
import * as stellarUtils from '../../services/stellar/stellar-utils';
import { Browser } from "@capacitor/browser";
import { capitalizeFirstLetter } from "../../services/utils/capitalizeFirst";
import { App, BackButtonListenerEvent } from '@capacitor/app';

type MyModalProps = {

    operation: DisplayableOperation;
    closeAction: Function;
    asset: Asset
}

const PaymentDetailsPage: React.FC<MyModalProps> = (props) => {

    // dealing with android back button and modals
    // App.addListener('backButton', (ev: BackButtonListenerEvent) => {
    //     props.closeAction()
    // });

    useEffect(() => {
        let backButtonListener: any;

        const setupBackButtonListener = async () => {
            backButtonListener = await App.addListener('backButton', (ev: BackButtonListenerEvent) => {
                props.closeAction();
            });
        };

        setupBackButtonListener();

        // Cleanup function
        return () => {
            backButtonListener?.remove();
        };
    }, [props.closeAction]);

    const { t, i18n } = useTranslation();
    //const stellarExperUIURL = `${import.meta.env.VITE_STELLAR_EXPERT_UI_URL}`;

    // const goToTransactionExplorer = async (transactionId: string) => {

    //     await Browser.open({ url: `${stellarExperUIURL}/tx/${transactionId}` });

    // }

    // console.log('the operation '+JSON.stringify(props.operation))

    const goToMoreInfoURL = async (url: string) => {

        await Browser.open({ url: `${url}` });

    }

    return (

        <>

            <IonHeader className="ion-no-border">
                <IonToolbar >
                    <IonButtons slot="start">
                        <IonButton onClick={() => { props.closeAction() }} color={'primary'}>
                            <IonIcon slot="icon-only" icon={closeOutline} />
                        </IonButton>
                    </IonButtons>
                    {/* <IonButtons slot="primary" hidden={props.operation.info?.kind===!'buy' || props.operation.info?.kind===!'sell'}>
                        <IonButton onClick={() => { goToMoreInfoURL(props.operation.info?.more_info_url as string) }}>
                            <IonIcon slot="icon-only" icon={openOutline} color="danger" />
                        </IonButton>
                    </IonButtons> */}

                </IonToolbar>
            </IonHeader>

            <AppHeader
                title={(props.operation.isRecipient ? '+' : '-') + `${parseFloat(props.operation.amount.toString()).toFixed(props.asset.decimal_places)} ${props.operation.token.code}`}>
            </AppHeader>

            <IonContent>

                <IonItem lines='none'
                    className="paymentDetails_Item"
                >
                    <IonLabel slot='start'>
                        <IonText className="ion-text-wrap">
                            {
                                // props.operation.name?
                                // (
                                //     <h5>
                                //         {capitalizeFirstLetter(props.operation.name)}
                                //     </h5>
                                // ):
                                // (props.operation.description)?
                                // (
                                //     <h5>
                                //         {capitalizeFirstLetter(props.operation.description)}
                                //     </h5>
                                // ):
                                (props.operation.isRecipient) ?
                                    (
                                        <h5>
                                            {capitalizeFirstLetter(t('payment.details.received') as string)}
                                        </h5>
                                    ) :
                                    (
                                        <h5>
                                            {capitalizeFirstLetter(t('payment.details.sent') as string)}
                                        </h5>
                                    )

                            }

                        </IonText>
                        <IonNote className="tradeDetailsPage_IonNote">
                            {moment.unix(props.operation.timestamp).format("D MMM YYYY,h:mm")}
                        </IonNote>
                    </IonLabel>
                    <IonThumbnail className="paymentDetails_Thumbnail" slot="end">
                        <img src={props.asset.icon} />
                    </IonThumbnail>
                </IonItem>

                <IonCard className="ion-padding">
                    <IonItem lines='none' >
                        <IonNote slot='start' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                            {t('trade.details.status')}
                        </IonNote>
                        <IonNote slot='end' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                            {t('trade.details.status-LABEL-COMPLETED')}
                        </IonNote>
                    </IonItem>

                    <IonItem lines='none' >
                        {
                            props.operation.isRecipient ?
                                <IonNote slot='start' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                                    {t('payment.details.from')}
                                </IonNote>
                                :

                                <IonNote slot='start' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                                    {t('payment.details.to')}
                                </IonNote>
                        }

                        {
                            props.operation.name ?
                                (
                                    <IonNote slot='end' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                                        {capitalizeFirstLetter(props.operation.name)}
                                    </IonNote>
                                ) :

                                (
                                    <IonNote slot='end' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                                        {stellarUtils.shortenAccountId(props.operation.otherAccount.publicKey)}
                                    </IonNote>
                                )
                        }

                    </IonItem>

                    <IonItem lines='none' >

                        <IonNote slot='start' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                            {t('payment.details.amount')}
                        </IonNote>

                        <IonNote slot='end' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                            {parseFloat(props.operation.amount.toString()).toFixed(props.asset.decimal_places)} {props.asset.display_code}
                        </IonNote>
                    </IonItem>


                    <IonItem lines='none' hidden={!props.operation.memo} >

                        <IonNote slot='start' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                            {'Memo'}
                        </IonNote>

                        <IonNote slot='end' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                            {props.operation.memo as string}
                        </IonNote>
                    </IonItem>

                    <IonItem lines='none' hidden={!props.operation.description}>

                        <IonNote slot='start' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                            {t('payment.details.description')}
                        </IonNote>

                        <IonNote slot='end' className='tradeDetailsPage_IonNote' color='var(ion-text-color)'>
                            {props.operation.description}
                        </IonNote>
                    </IonItem>

                </IonCard>

            </IonContent>

            <IonFooter className="ion-no-border" hidden={(props.operation.info?.kind !== 'buy' || props.operation.info?.kind !== 'sell')}>
                <IonToolbar>

                    <IonButton
                        onClick={() => goToMoreInfoURL(props.operation.info?.more_info_url)}

                        type="submit"
                        expand="block"
                        id='pageFooterButton'>

                        {t('payment.details.btn.receipt.label')}
                    </IonButton>
                </IonToolbar>
            </IonFooter>

        </>

    )
}


export default PaymentDetailsPage